import type { ReactNode } from 'react';

/** Icons used by the application rail. Kept inline so they inherit the shell colour. */
export type NavIconName =
  | 'dashboard'
  | 'check'
  | 'vulnerability'
  | 'triage'
  | 'notification'
  | 'audit'
  | 'psirt'
  | 'database'
  | 'relations'
  | 'import'
  | 'users'
  | 'system';

export interface NavIconProps {
  name: NavIconName;
}

export function NavIcon({ name }: NavIconProps): ReactNode {
  const content: Readonly<Record<NavIconName, ReactNode>> = {
    dashboard: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="2" />
        <rect x="14" y="3" width="7" height="7" rx="2" />
        <rect x="3" y="14" width="7" height="7" rx="2" />
        <rect x="14" y="14" width="7" height="7" rx="2" />
      </>
    ),
    check: (
      <>
        <path d="M4 13.2 8.6 18 20 6.5" />
        <path d="M4 6.5h7" />
      </>
    ),
    vulnerability: (
      <>
        <path d="M12 3.2 21 19H3L12 3.2Z" />
        <path d="M12 8.5v4.7" />
        <path d="M12 16.6h.01" />
      </>
    ),
    triage: (
      <>
        <path d="M4 5h16l-6.2 7.1v5.4l-3.6 1.8v-7.2L4 5Z" />
        <path d="m16.3 16.2 1.4 1.4 2.8-3" />
      </>
    ),
    notification: (
      <>
        <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
        <path d="m4 7 8 6 8-6" />
      </>
    ),
    audit: (
      <>
        <path d="M6 3.5h9l3.5 3.5v13.5H6Z" />
        <path d="M14.5 3.5V7.5h4" />
        <path d="M9 11.5h6M9 15h3.5" />
        <circle cx="16.5" cy="17.5" r="0.4" />
      </>
    ),
    psirt: (
      <>
        <path d="M12 3.2 19 6v5.6c0 4.3-2.9 7.7-7 9.2-4.1-1.5-7-4.9-7-9.2V6l7-2.8Z" />
        <circle cx="12" cy="10.2" r="2.1" />
        <path d="M8.7 16c.7-1.6 1.8-2.4 3.3-2.4s2.6.8 3.3 2.4" />
      </>
    ),
    database: (
      <>
        <ellipse cx="12" cy="5.5" rx="8" ry="3" />
        <path d="M4 5.5v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
        <path d="M4 11.5v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
      </>
    ),
    relations: (
      <>
        <circle cx="6" cy="6" r="2.5" />
        <circle cx="18" cy="7" r="2.5" />
        <circle cx="12" cy="18" r="2.5" />
        <path d="m8.3 7 7.3-.1M7.3 8.2l3.5 7.6M16.8 9.1l-3.5 6.7" />
      </>
    ),
    import: (
      <>
        <path d="M12 3v11" />
        <path d="m7.5 9.5 4.5 4.6 4.5-4.6" />
        <path d="M4 15.5v4h16v-4" />
      </>
    ),
    users: (
      <>
        <circle cx="9" cy="8" r="3" />
        <path d="M3.5 19c.5-4 2.3-6 5.5-6s5 2 5.5 6" />
        <path d="M15 5.5a3 3 0 0 1 0 5.7M16.5 13.5c2.4.7 3.7 2.5 4 5.5" />
      </>
    ),
    system: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.3 13.5a7.8 7.8 0 0 0 0-3l2-1.5-2-3.4-2.4 1a8.2 8.2 0 0 0-2.6-1.5L14 2.5h-4l-.3 2.6a8.2 8.2 0 0 0-2.6 1.5l-2.4-1-2 3.4 2 1.5a7.8 7.8 0 0 0 0 3l-2 1.5 2 3.4 2.4-1a8.2 8.2 0 0 0 2.6 1.5l.3 2.6h4l.3-2.6a8.2 8.2 0 0 0 2.6-1.5l2.4 1 2-3.4-2-1.5Z" />
      </>
    ),
  };

  return (
    <svg
      className="nav-icon"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {content[name]}
    </svg>
  );
}

export default NavIcon;
